module.exports = __webpack_public_path__ + "img/rlc.2a1bdb72.svg";